import * as React from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import useColoredTextParser from "@project-stories/../hooks/useColoredTextParser"; // adjust path as needed
import Headings from "@project-stories/elements/Headings/Headings";

export const NewsletterHeading = ({ settings, isMobile }) => {
    const alignmentClass = `text-${settings?.content_alignment}`;
    const headingText = settings?.heading_text;

    const headerStyle = isMobile
        ? settings?.heading_type_mobile
        : settings?.heading_type

    const renderFormattedTitle = useColoredTextParser({
        title: headingText,
        accentTitleParts: settings?.accent_title_parts,
        accentColor: settings?.accent_color,
        headerStyle,
        classes: alignmentClass,
        HeadingsComponent: Headings, // fallback to Paragraph below
    });

    return (
        <div className={`newsletter-signup__heading mb-3 ${alignmentClass}`}>
            {headingText && (renderFormattedTitle() ||
                <Paragraph 
                    text={headingText} 
                    type={`max-lg:text-center ${headerStyle}`} 
                />
            )}
        </div>
    );
};

export default NewsletterHeading;